import React, { useEffect, useState } from "react";
import { FaInstagram, FaTiktok, FaGlobe, FaChevronRight } from "react-icons/fa";
import { getAllboothsList, getCities, groupByCity } from "../../services/Booths";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ls from "local-storage";
import { event } from "../../utils/gtag";

const socials = [
  {
    icon: <FaInstagram />,
    url: "https://instagram.com/sukhakala.id",
  },
  {
    icon: <FaTiktok />,
    url: "https://tiktok.com/@sukhakala.id",
  },
  {
    icon: <FaGlobe />,
    url: "https://sukhakala.id",
  },
];

export default function LinksPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const utmSource = params.get("utm_source");
  const { cityID } = useParams();

  useEffect(() => {
    console.log(cityID);
    if (utmSource && window.gtag) {
      window.gtag("set", "user_properties", {
        utm_source: utmSource,
      });
    }
  }, [utmSource]);

  const [boothsList, setboothsList] = useState([]);
  const [cityList, setCityList] = useState([]);

  function fetchboothsList(cityID) {
    groupByCity(cityID).then((response) => {
      setboothsList(response.data);
    });
  }

  function fetchLS() {
    if (ls.get("userDetail")) {
      const userDetail = ls.get("userDetail");
    }
  }

  useEffect(() => {
    fetchboothsList(cityID);
    fetchLS();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-pink-50 flex flex-col items-center px-4 py-8">
      <img
        src="/latest-logo.jpg"
        alt="Sukhakala Logo"
        className="w-24 h-24 mb-4 rounded-full object-cover"
      />
      <h1 className="text-3xl font-bold text-center mb-2">
        Sukhakala Photobooth
      </h1>
      Keeping memories alive with the new ✨love language✨
      <br />
      <br />
      {/* Social Icons */}
      <div className="flex space-x-4">
        {socials.map((social, idx) => (
          <a
            key={idx}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              event({
                action: "click_link",
                category: "LinksPage",
                label: social.url,
              })
            }
            className="text-2xl text-pink-600 hover:text-pink-800 transition"
          >
            {social.icon}
          </a>
        ))}
      </div>

      {/* Branch List */}
      <div className="w-full max-w-2xl space-y-2 text-center mt-4">
        {boothsList.length === 0 ? (
          <div className="text-gray-500">Loading branches...</div>
        ) : (
          boothsList.map((cityGroup, cityIdx) => (
            <div key={cityIdx} className="w-full max-w-2xl mb-6">
              <h2 className="text-xl font-semibold mt-2 mb-4 text-center px-2">
                📍 {cityGroup.cityName}
              </h2>

              <div className="flex flex-col gap-3">
                {cityGroup.booths.map((booth, boothIdx) => (
                  <div
                    key={boothIdx}
                    className="bg-[#2b478e] text-white p-2.5 px-4 rounded-full flex items-center justify-between shadow-md hover:bg-[#e7ac46] transition-all border border-black cursor-pointer"
                    onClick={() => {
                      event({
                        action: "click_link",
                        category: "LinksPage",
                        label: booth.maps_name,
                      });
                      navigate('/booth/' + booth.id);
                    }}
                  >
                    {/* Gambar Thumbnail Lingkaran (Kiri) */}
                    <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 border border-gray-700 bg-gray-800">
                      <img
                        src={booth.image_url || "/logo.png"}
                        alt={booth.maps_name}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Text Tengah: Title & Merchant Tags */}
                    <div className="flex-1 px-3 text-center min-w-0">
                      <h3 className="font-bold text-white text-sm sm:text-base leading-tight truncate">
                        {booth.maps_name}
                      </h3>
                      {booth.merchant_tags && (
                        <p className="text-[11px] text-gray-400 mt-0.5 truncate tracking-wide font-mono">
                          {booth.merchant_tags}
                        </p>
                      )}
                    </div>

                    {/* Icon Chevron (Kanan) */}
                    <div className="flex items-center flex-shrink-0 pr-1 text-gray-400">
                      <FaChevronRight className="w-3.5 h-3.5 text-gray-300" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}